import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import type { FilterOptionItem } from '~/api/seller-after-sales/types/requests.types'

const sortAlphabetically = (array: Array<FilterOptionItem>) =>
  array.sort((a, b) => {
    const aInLowerCase = a.label.toLowerCase()
    const bInLowerCase = b.label.toLowerCase()
    if (aInLowerCase < bInLowerCase) return -1
    if (aInLowerCase > bInLowerCase) return 1

    return 0
  })

export function useMarketOptions() {
  const i18n = useI18n()

  const options = useMarketplace().marketplace.markets.map(
    ({ countryCode }: { countryCode: MarketCountryCode }) => ({
      label: i18n.country(countryCode),
      value: countryCode,
    }),
  )

  return sortAlphabetically(options)
}
